var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { createURLDescriptor, joinPaths } from './URLTools';
import { SimpleSubscription, createOrPassthroughObserver } from './Observable';
import { Status } from './Resolver';
import { SegmentType } from './Segments';
import { isRouteMapSteady } from './Maps';
import { createRoute } from './Route';
import { matchMappingAgainstPathname } from './Mapping';
import { HTTPMethod } from './HTTPMethod';

var RouteMapObservable =
/** @class */
function () {
  function RouteMapObservable(url, rootContext, pages, rootMapping, resolver, router, options) {
    var _this = this;

    this.handleUnsubscribe = function (observer) {
      var index = _this.observers.indexOf(observer);

      if (index !== -1) {
        _this.observers.splice(index, 1);
      }
    };

    this.handleResolverUpdate = function () {
      if (!_this.isRefreshing) {
        _this.refresh();
      } else if (!_this.isRefreshScheduled) {
        _this.isRefreshScheduled = true;
      }
    };

    this.refresh = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var allResolvableIds, i, item, pathname, _a, segment, resolutionIds, lastSegment, cachedLastSegment, patterns, j, expandedPatterns, k, routeMapArray, i_1, item, lastSegment, routeMap, i_2, _b, pathname, route, isSteady, i_3, observer;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              this.isRefreshScheduled = false;
              this.isRefreshing = true;
              allResolvableIds = [];
              i = 0;
              _c.label = 1;

            case 1:
              if (!(i < this.mapItems.length)) return [3
              /*break*/
              , 6];
              item = this.mapItems[i];
              pathname = item.pathname;
              _a = item.matcher.getResult(), segment = _a.segment, resolutionIds = _a.resolutionIds;
              lastSegment = segment.lastRemainingSegment || segment;
              cachedLastSegment = item.lastSegmentCache;
              item.segmentCache = segment;
              item.lastSegmentCache = lastSegment; // If an item in the map cannot be found, throws an error, or is
              // no longer referenced by other items, then remove it from the
              // map.
              //
              // Note that later items in the map should always be "from" earlier
              // items, so if an earlier item is removed, its referenced items
              // will still be removed.

              if (lastSegment.status === Status.Error || this.options.predicate && !this.options.predicate(lastSegment)) {
                this.removeFromQueue(item);
                return [3
                /*break*/
                , 1];
              } // If a redirect has been added or changed `to` location,
              // then add the location to the map.


              if (this.options.followRedirects && lastSegment.type === SegmentType.Redirect && lastSegment.status === Status.Ready && lastSegment.to && (!cachedLastSegment || cachedLastSegment.type !== SegmentType.Redirect || cachedLastSegment.status !== Status.Ready || !cachedLastSegment.to || cachedLastSegment.to !== lastSegment.to)) {
                this.addToQueue(lastSegment.to, item.depth + 1, pathname, item.order);
              }

              if (!(lastSegment.type === SegmentType.Switch && lastSegment.status === Status.Ready && (!cachedLastSegment || cachedLastSegment.type !== SegmentType.Switch || cachedLastSegment.status === Status.Busy))) return [3
              /*break*/
              , 5];
              patterns = lastSegment.switch.patterns;
              j = 0;
              _c.label = 2;

            case 2:
              if (!(j < patterns.length)) return [3
              /*break*/
              , 5];
              return [4
              /*yield*/
              , this.expandPatterns(joinPaths(pathname, patterns[j]))];

            case 3:
              expandedPatterns = _c.sent();

              for (k = 0; k < expandedPatterns.length; k++) {
                this.addToQueue(expandedPatterns[k], item.depth + 1, pathname, item.order + '.' + j);
              }

              _c.label = 4;

            case 4:
              j++;
              return [3
              /*break*/
              , 2];

            case 5:
              if (resolutionIds) {
                allResolvableIds = allResolvableIds.concat(resolutionIds);
              }

              i++;
              return [3
              /*break*/
              , 1];

            case 6:
              routeMapArray = [];

              for (i_1 = 0; i_1 < this.mapItems.length; i_1++) {
                item = this.mapItems[i_1];
                lastSegment = item.lastSegmentCache;

                if (lastSegment.type !== SegmentType.Switch && lastSegment.status !== Status.Error) {
                  routeMapArray.push([joinPaths(item.pathname, '/'), createRoute(createURLDescriptor(item.pathname, {
                    ensureTrailingSlash: false
                  }), item.segmentCache), item.order]);
                }
              } // This will replace any existing listener and its associated resolvables


              this.resolver.listen(this.handleResolverUpdate, allResolvableIds);
              routeMapArray.sort(function (x, y) {
                return x[2] < y[2] ? -1 : x[2] > y[2] ? 1 : 0;
              });

              if (this.isRefreshScheduled) {
                this.refresh();
              } else {
                routeMap = {};

                for (i_2 = 0; i_2 < routeMapArray.length; i_2++) {
                  _b = routeMapArray[i_2], pathname = _b[0], route = _b[1];
                  routeMap[pathname] = route;
                }

                isSteady = isRouteMapSteady(routeMap);

                for (i_3 = 0; i_3 < this.observers.length; i_3++) {
                  observer = this.observers[i_3];
                  observer.next(routeMap);

                  if (isSteady && observer.complete) {
                    observer.complete();
                  }
                }

                if (isSteady) {
                  this.resolver.unlisten(this.handleResolverUpdate);
                  delete this.rootContext;
                  delete this.mapItems;
                  delete this.router;
                  delete this.observers;
                  delete this.resolver;
                }

                this.isRefreshing = false;
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    };

    this.observers = [];
    this.mapItems = [];
    this.resolver = resolver;
    this.router = router;
    this.rootContext = rootContext;
    this.pages = pages;
    this.rootMapping = rootMapping;
    this.options = options;
    this.seenPathnames = new Set();
    var pathname = url.pathname; // A final '/' always indicates a Page or Redirect, and it
    // doesn't really make sense to build a map of a single page/redirect.

    if (pathname.substr(-1) === '/') {
      pathname = pathname.substr(0, pathname.length - 1);
    }

    this.addToQueue(pathname, 0);
  }

  RouteMapObservable.prototype.subscribe = function (onNextOrObserver, onError, onComplete) {
    if (!this.resolver) {
      throw new Error("Can't subscribe to an already-complete RoutingObservable.");
    }

    var observer = createOrPassthroughObserver(onNextOrObserver, onError, onComplete);
    this.observers.push(observer);
    var subscription = new SimpleSubscription(this.handleUnsubscribe, observer);

    if (this.observers.length === 1) {
      this.refresh();
    }

    return subscription;
  };

  RouteMapObservable.prototype.expandPatterns = function (pattern) {
    return __awaiter(this, void 0, void 0, function () {
      var expandedPatterns;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.options.expandPattern) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.options.expandPattern(pattern, this.router)];

          case 1:
            expandedPatterns = _a.sent();

            if (expandedPatterns) {
              return [2
              /*return*/
              , expandedPatterns];
            }

            _a.label = 2;

          case 2:
            return [2
            /*return*/
            , [pattern].filter(function (pattern) {
              return !/\/:/.test(pattern);
            })];
        }
      });
    });
  };

  RouteMapObservable.prototype.removeFromQueue = function (item) {
    var i = this.mapItems.indexOf(item);

    if (i !== -1) {
      this.mapItems.splice(i, 1);
    }
  };

  RouteMapObservable.prototype.addToQueue = function (pathname, depth, fromPathname, order) {
    if (order === void 0) {
      order = '0';
    }

    if (this.seenPathnames.has(pathname)) {
      return;
    }

    if (!this.options.maxDepth || depth <= this.options.maxDepth) {
      this.seenPathnames.add(pathname);
      var url = createURLDescriptor(pathname, {
        ensureTrailingSlash: false
      });
      var rootEnv = {
        context: this.rootContext,
        hash: '',
        headers: {},
        method: HTTPMethod.Get,
        params: {},
        pathname: '',
        mountname: '',
        query: url.query,
        search: url.search,
        router: this.router,
        unmatchedPathnamePart: url.pathname,
        url: url
      };
      var matchEnv = matchMappingAgainstPathname(rootEnv, this.rootMapping, false);

      if (matchEnv) {
        this.mapItems.push({
          url: url,
          fromPathname: fromPathname,
          depth: depth,
          pathname: pathname,
          order: order,
          matcher: new this.pages({
            appendFinalSlash: false,
            env: matchEnv,
            resolver: this.resolver,
            withContent: this.options.withContent
          })
        });
      }
    }
  };

  return RouteMapObservable;
}();

export { RouteMapObservable };